// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__qPITF","tab":"ProcedureTabs_tab__1nkvp"};